import { createContext, useContext } from 'react';

export const TranslationContext = createContext();
if (process.env.NODE_ENV === 'development') {
  TranslationContext.displayName = 'TranslationContext';
}

export function useStravaTranslations() {
  const context = useContext(TranslationContext);

  if (!context) {
    throw new Error(
      'useStravaTranslations must be used within the TranslationContext.Provider'
    );
  }

  return context;
}
